enum InputType {
  EMAIL_MOBILE = 'EMAIL_MOBILE',
  EMAIL = 'EMAIL',
  MOBILE = 'MOBILE',
}

export { InputType };
